import { render, staticRenderFns } from "./top-balance.vue?vue&type=template&id=de9792ec&"
import script from "./top-balance.vue?vue&type=script&lang=js&"
export * from "./top-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports